module.exports = __webpack_public_path__ + "pc/img/swiper_06.1db4f27e.jpg";